import { render, staticRenderFns } from "./yearly_product_compare.vue?vue&type=template&id=f05ee1f2&scoped=true"
import script from "./yearly_product_compare.vue?vue&type=script&lang=js"
export * from "./yearly_product_compare.vue?vue&type=script&lang=js"
import style0 from "./yearly_product_compare.vue?vue&type=style&index=0&id=f05ee1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ee1f2",
  null
  
)

export default component.exports